import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import { useBakeryCatalogState } from "../hooks/useBakeryCatalogState";

type BakeryCatalogState = ReturnType<typeof useBakeryCatalogState>;

const BakeryCatalogContext = createContext<BakeryCatalogState | null>(null);

type BakeryCatalogProviderProps = {
  children: ReactNode;
};

export function BakeryCatalogProvider({ children }: BakeryCatalogProviderProps) {
  const state = useBakeryCatalogState();

  return (
    <BakeryCatalogContext.Provider value={state}>{children}</BakeryCatalogContext.Provider>
  );
}

export function useBakeryCatalog() {
  const context = useContext(BakeryCatalogContext);
  if (!context) {
    throw new Error("useBakeryCatalog must be used within BakeryCatalogProvider");
  }
  return context;
}
